import { render, staticRenderFns } from "./IndividualAddress.vue?vue&type=template&id=5be352c3"
import script from "./IndividualAddress.vue?vue&type=script&lang=js"
export * from "./IndividualAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports